import { render, staticRenderFns } from "./ListRecebedores.vue?vue&type=template&id=67a3764d"
import script from "./ListRecebedores.vue?vue&type=script&lang=js"
export * from "./ListRecebedores.vue?vue&type=script&lang=js"
import style0 from "./ListRecebedores.vue?vue&type=style&index=0&id=67a3764d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports